import { useState, useEffect } from 'react';

const testimonials = [
  {
    quote: "Refer many people to McCrea's Landscaping & Irrigation for good reason. Quick response, always answers texts or calls, does excellent work, they're professional and I know they're insured. They've even surprised me and performed yard maintenance because they knew it needed it! Excellent service.",
    author: 'Sharon Gainey',
    rating: 5,
  },
  {
    quote: "Gary has been helping with my flowerbeds for around 20 years…he does an excellent job. He also did a stone patio & sidewalk for us & we were so pleased with his work. Highly recommend him without any reservations. A+",
    author: 'Janet',
    rating: 5,
  },
  {
    quote: "Gary has handled mine and my families irrigation systems for years. There is no one local that can compete with him. He's honest and fair with everything he does. Great company that I highly recommend.",
    author: 'J Carr',
    rating: 5,
  },
  {
    quote: "I had a great 30+  years with this landscaping company. The crew was professional, friendly, and showed up on time. They listened to what I wanted, offered helpful suggestions, and delivered results that exceeded my expectations. My yard looks cleaner, healthier, and more put-together than it has in years.",
    author: 'Carol Lynne Thompson',
    rating: 5,
  },
  {
    quote: "Very satisfied. He's been managing multiple properties for me over the last 10 years.",
    author: 'Phillip Farrior',
    rating: 5,
  },
];

export default function TestimonialsSlider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-emerald-800">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <div className="flex items-center justify-center space-x-2 mb-6">
            <div className="w-2 h-2 bg-emerald-400 rounded-full"></div>
            <span className="text-white/80 font-semibold tracking-wider text-sm uppercase">
              Google Reviews
            </span>
          </div>
        </div>

        <div className="relative">
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-16 w-12 h-12 flex items-center justify-center border-2 border-white/30 hover:border-white rounded-full text-white transition-all cursor-pointer hidden lg:flex"
          >
            <i className="ri-arrow-left-line text-xl"></i>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-16 w-12 h-12 flex items-center justify-center border-2 border-white/30 hover:border-white rounded-full text-white transition-all cursor-pointer hidden lg:flex"
          >
            <i className="ri-arrow-right-line text-xl"></i>
          </button>

          <div className="overflow-hidden">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className={`transition-opacity duration-500 ${
                  index === currentIndex ? 'opacity-100' : 'opacity-0 absolute inset-0'
                }`}
              >
                <div className="text-center">
                  <i className="ri-double-quotes-l text-5xl text-emerald-400 mb-6 inline-block"></i>
                  <p className="text-2xl lg:text-3xl font-serif text-white leading-relaxed mb-8 font-light">
                    {testimonial.quote}
                  </p>
                  <div className="flex items-center justify-center space-x-3 mb-3">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                    ))}
                  </div>
                  <div className="flex items-center justify-center space-x-2">
                    <div className="font-bold text-xl text-white">{testimonial.author}</div>
                    <span className="text-white/60">•</span>
                    <span className="text-white/80 text-sm">Google Review</span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="flex justify-center space-x-3 mt-12">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-white w-8' : 'bg-white/40'
                }`}
              ></button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
